/**
 *
 * Ask
 *
 */

import { QaContentModelMixin } from './model';

import QaContent from '@/components/QA/Content.vue';

export const QaContentMixin = {
  name: 'QaContentMixin',

  mixins: [QaContentModelMixin],

  components: {
    'qa-content': QaContent,
  },

  data: () => {
    return {
      uploadQaImg: () => [],
    };
  },

  computed: {
    c_isQaContentReady() {
      return !this.c_isQaContentBlank;
    },
  },

  methods: {
    handleImageAdded({ uploadQaImg }) {
      this.uploadQaImg = uploadQaImg;
    },

    clearQaContent() {
      this.qaContent = '';
    },
  },
};

export default QaContentMixin;
